function moveCopyright() {
  const copyright = document.querySelector('.footer__copyright');
  const nav = document.querySelector('.footer__nav');
  const bottom = document.querySelector('.footer__bottom');

  if (!copyright || !nav || !bottom) return;

  if (window.innerWidth < 1024) {
    nav.appendChild(copyright);
  } else {
    bottom.appendChild(copyright);
  }
}

moveCopyright();
window.addEventListener('resize', moveCopyright);

const newsletterLinks = document.querySelectorAll('a[href*="/pages/newsletter"]');
const popup = document.getElementById('NewsletterPopup');
const closeBtn = document.getElementById('NewsletterPopupClose');
const submitBtn = document.getElementById('NewsletterPopupSubmit');
const emailInput = document.getElementById('NewsletterPopupEmail');
const errorMsg = document.getElementById('NewsletterPopupError');

function openPopup() {
  popup.removeAttribute('hidden');
  popup.style.opacity = '1';
  document.body.style.overflow = 'hidden';
}

function closePopup() {
  popup.setAttribute('hidden', '');
  popup.style.opacity = '';
  popup.style.transition = '';
  document.body.style.overflow = '';
}

function closePopupSmooth() {
  popup.style.transition = 'opacity 0.5s ease';
  popup.style.opacity = '0';
  setTimeout(function() {
    closePopup();
  }, 500);
}

if (popup) {
  newsletterLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  popup.querySelector('.newsletter-popup__overlay').addEventListener('click', closePopup);

  document.addEventListener('keyup', function(e) {
    if (e.key === 'Escape') closePopup();
  });

  if (window.location.search.includes('customer_posted=true')) {
    history.replaceState(null, '', window.location.pathname);

    var box = popup.querySelector('.newsletter-popup__box');
    var formWrapper = popup.querySelector('.newsletter-popup__form-wrapper');
    var title = popup.querySelector('.newsletter-popup__title');

    if (formWrapper) formWrapper.style.display = 'none';
    if (title) title.style.display = 'none';
    if (closeBtn) closeBtn.style.display = 'none';
    if (box) box.classList.add('success');

    openPopup();

    setTimeout(function() {
      closePopupSmooth();
    }, 3000);

    popup.querySelector('.newsletter-popup__overlay').addEventListener('click', closePopupSmooth);
  }

  if (emailInput) {
    emailInput.addEventListener('input', function() {
      if (emailInput.value.length > 0) {
        submitBtn.classList.add('is-active');
      } else {
        submitBtn.classList.remove('is-active');
      }
    });
  }

  const newsletterForm = document.getElementById('NewsletterPopupForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      const email = emailInput ? emailInput.value.trim() : '';
      if (!email || !email.includes('@')) {
        e.preventDefault();
        if (errorMsg) errorMsg.removeAttribute('hidden');
        return;
      }
      if (errorMsg) errorMsg.setAttribute('hidden', '');
      if (submitBtn) submitBtn.textContent = '...';
    });
  }
}